import { ActionTypes } from "../constants/action-types";

export const setDrawerSection = (val) => {
  return {
    type: ActionTypes.SIGNIN_DRAWER,
    payload: val,
  };
};

export const setScrollPos=(value)=>{
  return {
    type:ActionTypes.SET_SCROLL_POS,
    payload:value,
  }
}